import { ChangeDetectionStrategy, Component, ApplicationRef, ChangeDetectorRef, ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams, Events, AlertController, Content, Platform } from 'ionic-angular';
import { LoginProvider } from '../../providers/login/login';
import { AppState } from '../../config/state';
import { CoBookScannerPopoverComponent } from '../../components/co-book-scanner-popover/co-book-scanner-popover';
import { PopoverController } from 'ionic-angular/components/popover/popover-controller';
import { IlsProvider } from '../../providers/ils/ils';
import { ToastAlertsProvider } from '../../providers/toast-alerts/toast-alerts';
import { CoNgxKeyboardComponent } from '../../components/co-ngx-keyboard/co-ngx-keyboard';
import { TimeoutFunctionsProvider } from '../../providers/timeout-functions/timeout-functions';
import { CoEmailInputComponent } from '../../components/co-email-input/co-email-input';
import moment from 'moment';
import { MailProvider } from '../../providers/mail/mail';
import { NovelistProvider } from '../../providers/novelist/novelist';
import { PrintingProvider } from '../../providers/printing/printing';
import { CoSelfcheckAccountPage } from '../../pages/co-selfcheck-account/co-selfcheck-account';
import isIsbn from 'is-isbn';
import { HidScannerProvider } from '../../providers/hid-scanner/hid-scanner';

@IonicPage()
@Component({
  selector: 'page-co-selfcheck-checkin',
  templateUrl: 'co-selfcheck-checkin.html',
})
export class CoSelfcheckCheckinPage {
  @ViewChild(Content) content: Content;
  private checkins: any[] = [];
  private page: number = 1;
  private checkinsRunning: number = 0;
  private currentScan: any = [];
  private listenFunc: any;
  private osk: any;
  private checkinStage: string = "loading";
  private novelistResults: any[] = [];
  private wideScreen: boolean;
  private menuSide = "right";
  private logoutTimer: number = 2000;
  private itemsPerPage: number = 0;
  private pageAmount: number = 0;
  private patron : any;
  private hidSubscription: any;
  constructor(public navCtrl: NavController, public navParams: NavParams, private state: AppState, private loginProvider: LoginProvider, public popoverCtrl: PopoverController, private ilsProvider: IlsProvider, private toast: ToastAlertsProvider, private ref: ChangeDetectorRef, private events: Events, private timeout: TimeoutFunctionsProvider, private mailProvider: MailProvider, private novelist: NovelistProvider, private printingProvider: PrintingProvider, private platform: Platform, private alertCtrl: AlertController, private hidScanner: HidScannerProvider) {
    this.events.subscribe('timeoutCalled', () => this.timeout.doLogoutFunctions(this));

    this.events.subscribe('patronLoggedIn', (login) => {
      this.content.resize();
    });
    this.wideScreen = this.platform.width() > 600 && (this.state.sharedScreen || this.state.staff || !this.state.cordovaAvailable);

    window.onresize = (e) => {
      this.wideScreen = this.platform.width() > 600 && (this.state.sharedScreen || this.state.staff || !this.state.cordovaAvailable);
    };
    window.onresize = (e) => {
      setTimeout(() => {
        if (this.platform.width() > 600 && (this.state.sharedScreen || this.state.staff || !this.state.cordovaAvailable)) {
          this.wideScreen = true;
        } else if (this.platform.isLandscape() && (this.state.sharedScreen || this.state.staff || !this.state.cordovaAvailable)) {
          this.wideScreen = true;
        } else {
          this.wideScreen = false;
        }
      }, 225)

    };
  }
  onDomChange(event){
		if (!this.state.cordovaAvailable){
			this.itemsPerPage = Math.floor((event.target.clientHeight - 192)/101);
    }
  }
  calcPageAmount(){
    this.pageAmount = Math.ceil(this.checkins.length / this.itemsPerPage);
    return this.pageAmount;
  }
  get successfulCheckins() {
    return this.checkins.filter(c => c.status);
  }
  ngOnInit(): void {
    this.state.novelistArray = [];
    this.checkins = [];
    // this.checkins.push({"status":true,"id":"4004394682","type":"checkin","item":{"itemIdentifier":"4004394682","titleIdentifier":"It can't happen here / Sinclair Lewis ; with an introduction by Michael Meyer and a new afterword by","mediaType":null,"itemProperties":"","checkoutOk":true,"screenMessage":[]}})
    // this.checkins.push({"status":true,"id":"4004394682","type":"checkin","item":{"itemIdentifier":"4004394682","titleIdentifier":"It can't happen here / Sinclair Lewis ; with an introduction by Michael Meyer and a new afterword by","mediaType":null,"itemProperties":"","checkoutOk":true,"screenMessage":[]}})
    // this.checkins.push({"status":true,"id":"4004394682","type":"checkin","item":{"itemIdentifier":"4004394682","titleIdentifier":"It can't happen here / Sinclair Lewis ; with an introduction by Michael Meyer and a new afterword by","mediaType":null,"itemProperties":"","checkoutOk":true,"screenMessage":[]}})
    // this.checkins.push({"status":true,"id":"4004394682","type":"checkin","item":{"itemIdentifier":"4004394682","titleIdentifier":"It can't happen here / Sinclair Lewis ; with an introduction by Michael Meyer and a new afterword by","mediaType":null,"itemProperties":"","checkoutOk":true,"screenMessage":[]}})
    // this.checkins.push({"status":true,"id":"4004394682","type":"checkin","item":{"itemIdentifier":"4004394682","titleIdentifier":"It can't happen here / Sinclair Lewis ; with an introduction by Michael Meyer and a new afterword by","mediaType":null,"itemProperties":"","checkoutOk":true,"screenMessage":[]}})
    // this.checkins.push({"status":true,"id":"4004394682","type":"checkin","item":{"itemIdentifier":"4004394682","titleIdentifier":"It can't happen here / Sinclair Lewis ; with an introduction by Michael Meyer and a new afterword by","mediaType":null,"itemProperties":"","checkoutOk":true,"screenMessage":[]}})
    // this.checkins.push({"status":true,"id":"4004394682","type":"checkin","item":{"itemIdentifier":"4004394682","titleIdentifier":"It can't happen here / Sinclair Lewis ; with an introduction by Michael Meyer and a new afterword by","mediaType":null,"itemProperties":"","checkoutOk":true,"screenMessage":[]}})
  }
  ionViewWillEnter(): void {
    this.loginProvider.getCurrent().then(res => {
      if(res) {
        this.patron = res;
      }
      if(this.navParams.get('scan')) {
        this.checkinStage = 'checkin';
        this.checkinBarcode(this.navParams.get('scan'));
      } else {
        this.showBookScannerPopup;
      }
      this.showBookScannerPopup(true);
      this.hidSubscription = this.hidScanner.scan.subscribe(value => {
        if(this.checkinStage === 'checkin') this.checkinBarcode(value);
      });
      this.hidScanner.start();
    })
  }
  ionViewWillLeave(): void {
    if(this.hidSubscription) this.hidSubscription.unsubscribe();
    this.hidScanner.stop();
  }

  checkinBarcode(barcode): void {
    if (barcode.length == 13 && isIsbn.validate(barcode.toString())) {
      setTimeout(() => this.toast.showAlert('', 'Error - Please scan the library barcode and not the ISBN number', 'warning', 5000), 0);
    } else {
      this.checkinBook(barcode);
    }
  }

  checkinDone() {
    this.checkinStage = 'done';
  }

  checkinDoneMobile(receipt, event?) {
    if (receipt) {
      let inputPopup;
      let customClass = 'custom-email-input-popover';
      let successfulItems = this.successfulCheckins.length;
      inputPopup = this.popoverCtrl.create(CoEmailInputComponent, { inputType: 'email', email: this.patron && this.patron.email ? this.patron.email : '' }, { cssClass: customClass });
      let barcodeDetails, emailVars;
      let emailList = "";
      inputPopup.present({ ev: event || false });
      inputPopup.onDidDismiss(email => {
        if (email && email.info) {
          this.successfulCheckins.forEach(checkin => {
            //   let status;
            //   book.bookPassed ? status = 'Passed' : status = 'Failed';
            emailList += `Title: ${checkin.item.titleIdentifier} \r\n Id: ${checkin.item.itemIdentifier} \r\n Due: ${moment(checkin.dueDate).format('MM/DD/YYYY')} \r\n \r\n`
          });
          if (this.patron && this.patron.barcode) {
            barcodeDetails = `Customer ID: **********${this.patron.barcode.split('').reverse().slice(0, 4).reverse().join('')}`
          }
          emailVars = {
            first_name: '',
            screen_type: 'Checkin',
            branch_name: '',
            barcode_end: barcodeDetails || '',
            book_list: encodeURIComponent(emailList),
            // book_list: emailList,
            past_tense: 'checked in',
            total: successfulItems
          }
          this.patron && this.patron.firstName ? emailVars.first_name = this.patron.firstName : emailVars.first_name = '';
          this.mailProvider.sendBookReceipt(email.info, emailVars, true).then(res => {
            if (res.status) {
              this.toast.showAlert('', 'Your receipt has been sent!', 'success', 5000);
              this.navCtrl.pop();
            } else {
              this.toast.triggerToast('Send failed, please retry', '');
            };
          });
        }
      });
    } else {
      this.navCtrl.pop();
    }
  }

  showBookScannerPopup(stopPop) {
    let customClass = 'custom-barcode-scanner-popover';
    let popover = this.popoverCtrl.create(CoBookScannerPopoverComponent, { type: 'book', stopNavPop: stopPop, scope: 'checkin' }, { cssClass: customClass });

    if (this.state.cordovaAvailable){
      popover.present({
        ev: '',
        animate: false
      });

      popover.onDidDismiss(data => {
        this.checkinStage = 'checkin';
        if (data && data.info) {
          this.checkinBarcode(data.info);
        } else if (this.checkins.length === 0) {
          //   this.logout();
        }
      });
    } else {
      this.checkinStage = 'checkin';
    }
  }
  showScanner() {
    if (this.state.enableOnScreenKeyboard) {
      this.osk = this.popoverCtrl.create(CoNgxKeyboardComponent, { mode: 'standalone' }, { cssClass: "custom-keyboard-popover-bottom" });
      this.osk.present();
      this.osk.onDidDismiss(data => {
        if (data && data.length > 0) {
          this.checkinBarcode(data);
        }
      });
    }
  }
  checkinBook(barcode): void {
    if (this.checkins.findIndex(b => b.item.itemIdentifier === barcode) === -1) {
      this.checkinsRunning++;
      if (this.state.demo) {
        this.ilsProvider.getBibDetailsFromId(barcode).then(bib => {
          if (bib) {
            if (bib.isbns && bib.isbns.length > 0) {
              this.novelist.getItemDetailsFromISBN(bib.isbns[0]).then(result => {
                if (result) this.state.novelistArray.push(result);
              }).catch(err => { });
            }
            this.checkins.push({
              "status": true,
              "type": "checkin",
              "id": barcode,
              "item": {
                "itemIdentifier": barcode,
                "titleIdentifier": bib.title,
                "mediaType": null,
                "itemProperties": "",
                "checkinOk": true,
                "screenMessage": []
              }
            });
            this.playSound(true);
          } else {
            this.playSound(false);
          }
          this.checkinsRunning--;
        }).catch(err => {
          this.playSound(false);
        });
      } else {
        this.ilsProvider.checkinBook(barcode, this.state.locationId.toString()).then(checkin => {
			try{
				this.checkinsRunning--;
				if(checkin && checkin.item){
					this.checkins.unshift(checkin);
					if (checkin.status && this.state.patron) {
						this.state.patron.changedItems.push({
						"type": "checkin",
						"id": barcode,
						"bib": {
							"id": barcode,
							"title": checkin.item.titleIdentifier,
							"format": checkin.item.mediaType,
							"author": ""
						}
						});
						this.playSound(true);
					} else {
						this.playSound(false);
					}
				}else{
					// console.log(`checking in ${barcode} for ${this.patron.barcode} failed`);
					this.toast.triggerToast("There was a problem checking in this item, please try again", '', 'error', 6000);
					this.playSound(false);
				}
			}catch(err){
				console.error(err);
				this.playSound(false);
			}
        });
      }
    } else {
      this.toast.triggerToast("You have already checked in this item!", '', 'warning', 6000);
    }
    if(!this.state.cordovaAvailable) this.page = this.pageAmount;
  }
  myAccount() {
    this.state.nav.push(CoSelfcheckAccountPage);
  }
  closeCheckin(logout: Boolean) {
    if (this.successfulCheckins.length === 0 || this.checkinStage === 'done') {
      if (logout) {
        this.logout();
      } else {
        this.state.nav.popToRoot();
      }
      return;
    }
    let alert = this.alertCtrl.create({
      title: 'Close check-in',
      cssClass: 'confirm-alert',
      message: 'Before you log out, do you want a receipt for your check-ins?',
      buttons: [
        {
          text: 'No',
          role: 'cancel',
          cssClass: 'confirm-button-outline',
          handler: () => {
            if (logout) {
              this.logout();
            } else {
              this.state.nav.popToRoot();
            }
            return;
          }
        },
        {
          text: 'Yes',
          cssClass: 'confirm-button',
          handler: () => {
            this.checkinDone();
          }
        }
      ]
    });
    alert.present();
  }
  logout() {
    let alert = this.alertCtrl.create({
      title: 'Logout',
      cssClass: 'confirm-alert',
      message: 'Do you want to log out?',
      buttons: [
        {
          text: 'No',
          role: 'cancel',
          cssClass: 'confirm-button-outline',
          handler: () => {
            return;
          }
        },
        {
          text: 'Yes',
          cssClass: 'confirm-button',
          handler: () => {
            this.instantLogout();
          }
        }
      ]
    });
    alert.present();
  }
  instantLogout() {
    this.loginProvider.logout(this.logoutTimer).then( done =>{
      if( done ){
        this.state.nav.popToRoot();
      }
    });
  }
  playSound(status){
    if (this.state.enableSounds) {
      const sound = status?new Audio('assets/sounds/checkoutsuccess.mp3'):new Audio('assets/sounds/checkoutfailed.mp3');
      sound.loop = false;
      sound.play();
    }
  }
  sendReceipt(notification, event) {
    let inputPopup;
    let customClass = 'custom-email-input-popover';
    let successfulItems = this.successfulCheckins.length;

    if (this.state.customStrings.checkin && this.state.customStrings.checkin.customLogoutMsg){
      this.state.logoutSummary = this.state.customStrings.checkin.customLogoutMsg;
      this.logoutTimer = 6000;
    } else {
      this.state.logoutSummary = "";
      this.logoutTimer = 2000;
    }
    // console.log(this.state.customStrings.checkout, this.state.logoutSummary);

    switch (notification) {
      case ('email'):
        inputPopup = this.popoverCtrl.create(CoEmailInputComponent, { inputType: 'email' }, { cssClass: customClass });
        let barcodeDetails, emailVars;
        let emailList = "";
        inputPopup.present({ ev: event });
        inputPopup.onDidDismiss(email => {
          if (email && email.info) {
            this.successfulCheckins.forEach(checkin => {
            //   let status;
            //   book.bookPassed ? status = 'Passed' : status = 'Failed';
              emailList += `Title: ${checkin.item.titleIdentifier} \r\n Id: ${checkin.item.itemIdentifier} \r\n Due: ${moment(checkin.dueDate).format('MM/DD/YYYY')} \r\n \r\n`
            });
            if (this.patron && this.patron.id && this.patron.barcode) {
              barcodeDetails = `Customer ID: **********${this.patron.barcode.split('').reverse().slice(0, 4).reverse().join('')}`
            }
            emailVars = {
              first_name: '',
              screen_type: 'Check-in',
              branch_name: '',
              barcode_end: barcodeDetails || '',
              book_list: encodeURIComponent(emailList),
              // book_list: emailList,
              past_tense: 'checked in',
              total: successfulItems
            }
            this.patron && this.patron.firstName ? emailVars.first_name = this.patron.firstName : emailVars.first_name = '';
            this.mailProvider.sendBookReceipt(email.info, emailVars, true).then(res => {
              if (res.status) {
                this.toast.showAlert('', 'Your receipt has been sent!', 'success', 3000);
              } else {
                this.toast.triggerToast('Send failed, please retry', '');
              };
            });
          }
        });
        break;
      case ('phone'):
        inputPopup = this.popoverCtrl.create(CoEmailInputComponent, { inputType: 'phone' }, { cssClass: customClass });
        inputPopup.present({ ev: event });
        inputPopup.onDidDismiss(phone => {
          if (phone && phone.info) {

            this.mailProvider.sendBookReceipt(`1${phone.info}`, { first_name: this.patron && this.patron.firstName ? this.patron.firstName : "", screen_type: 'check in', branch_name: this.state.branchInformation.name, total: successfulItems }, false).then(res => {
              if (res.status) {
                this.toast.triggerToast('Your receipt has been sent!', '', 'success', 3000);
              } else {
                this.toast.triggerToast('Send failed, please retry', '');
              }
            });
          }
        });
        break;
      case ('print'):
        // console.log(this.successfulCheckouts)
        // let preview = this.popoverCtrl.create(CoPrintPreviewPopoverComponent, { receiptInfo: this.successfulCheckouts, screenType: 'Checkout', patron: this.state.patron, pastTense: 'checked out', submitTime: moment(), idents: [] });
        // preview.present();
        this.printingProvider.printCheckoutItemReceipt({ receiptInfo: this.successfulCheckins, screenType: 'Checkin', patron: this.state.patron, pastTense: 'checked in', submitTime: moment(), novelistResults: this.novelistResults }, false, this.logoutTimer);
        break;
      default:
        this.instantLogout();
      break;
    }
  }


}



// WEBPACK FOOTER //
// ./src/pages/co-selfcheck-checkin/co-selfcheck-checkin.ts